import EFPicture from 'elem/compCommon/EFPicture';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import Battery from '@elem/SVGIcon/VanlifeRoadtrips/Battery';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function L() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const LOCAL_SITES: string[] = ['za', 'kr'];
    const icons: any = [
        {
            icon: <Battery />,
            text: t('secL_tag1'),
        },
        {
            icon: <PlugAndPlay />,
            text: t('secL_tag2'),
        },
        {
            icon: <PortableDesign />,
            text: t('secL_tag3'),
        },
    ];
    return (
        <div id="vanlife-roadtrips-L" className={`vanlife-roadtrips-L ${css['vanlife-roadtrips-L']}`}>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/vanlife-roadtrips/11${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcMobile={`/responsive/picture/vanlife-roadtrips/11_375${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    alt={t('secL_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secL_title')}</p>
                    <p className="desc">{t('secL_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
